import { render } from "./EditResource.vue?vue&type=template&id=fbb125f2"
import script from "./EditResource.vue?vue&type=script&lang=js"
export * from "./EditResource.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__